<template>
  <div v-if="clientInfo.loaded">
    <v-tooltip bottom>
      <span slot="activator">{{ clientInfo.shortTitle | NoEmpty}}</span>
      <span>{{ clientInfo.title | NoEmpty}}</span>
    </v-tooltip>
  </div>
  <div v-else>{{clientId}}</div>
</template>

<script>
  import _ from 'lodash'
  import {mapActions, mapState} from 'vuex'
  import NoEmpty from '../../Filters/NoEmpty'

  export default {
    name: 'client-info',
    components: {},
    filters: {
      NoEmpty
    },
    props: {
      clientId: {
        type: String,
        required: true
      },
      shortTitleLength: {
        type: Number,
        default: 15
      },
      title: {
        type: String,
        default: ''
      }
    },
    data() {
      return {}
    },
    computed: {
      ...mapState({
        availableClients: 'availableClients'
      }),
      client() {
        if (this.availableClients.length === 0) {
          return null
        }

        return _.find(this.availableClients, it => it.id === this.clientId);
      },
      clientInfo() {
        if (!this.client && !this.title) {
          return {
            loaded: false
          }
        }

        return {
          loaded: true,
          shortTitle: this.title || _.truncate(this.client.title, {
              length: this.shortTitleLength
            }),
          title: this.title || this.client.title
        }
      }
    },
    mounted() {
      this.fetchInitDataIfRequired()
    },
    methods: {
      ...mapActions({
        fetchInitDataIfRequired: 'fetchInitDataIfRequired'
      }),
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/ClientInfo.vue